import React from 'react'
import { connect } from 'react-redux'
import { number, string } from 'prop-types'

const MetaData = ({ count, category }) => (
  <div className="meta-information">
    <p>
      Showing{' '}
      <span>
        {count} {category} signs
      </span>{' '}
      around above location. <span>Tap</span> to view more options.
    </p>
  </div>
)

MetaData.propTypes = {
  count: number.isRequired,
  category: string.isRequired,
}

const mapStateToProps = ({ signsState, spi }) => ({
  count: signsState.signs.length,
  category: spi.category[0],
})

export default connect(mapStateToProps)(MetaData)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/MetaData/index.jsx